/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  exportDashBoardLeavesData,
  exportDashBoardTimeLogData,
  fetchDashBoardData,
} from "./fetchData";
import { Toast } from "primereact/toast";
import TlPieChart from "./TlPieChart";
import { ProgressSpinner } from "primereact/progressspinner";
import { headerTemplate } from "../User Management/templates";
import { Tooltip } from "primereact/tooltip";
import {
  LeavesManagementIcon,
  TimelogManagementIcon,
} from "../../../layout/sidebar/SideBarSVGs";
import { Button } from "primereact/button";
import CalendarDateSelector from "../common/CalendarDateSelector";
import { Skeleton } from "primereact/skeleton";

const TimeLogDashboard = () => {
  const toast = useRef<Toast>(null);

  const [exportTimelogLoading, setExportTimelogLoading] = useState(false);
  const [exportLeavesLoading, setExportLeavesLoading] = useState(false);
  const [dashBoardDataLoading, setDashBoardDataLoading] = useState(false);
  const [dashBoardData, setDashBoardData] = useState<any>([]);
  const [totalTimeLogsCounts, setTotalTimeLogsCounts] = useState({
    totalPendingTimelogs: "0",
    totalSubmittedTimelogs: "0",
    totalManagerSubmittedTimeLogs: "0",
    totalApprovedByManagerTimeLogs: "0",
    totalRejectedByManagerTimeLogs: "0",
    totalRejectedTimeLogs: "0",
    totalApprovedTimelogs: "0",
    totalMissingTimeLogs: "0",
  });

  const [filters, setFilters] = useState<any>({
    startDate: null,
    endDate: null,
  });

  const [sortFilter, setSortFilter] = useState({
    sortField: "displayName",
    sortOrder: false,
  });

  useEffect(() => {
    if (filters.startDate && filters.endDate) {
      fetchDashBoardData(
        setDashBoardData,
        setTotalTimeLogsCounts,
        setDashBoardDataLoading,
        filters,
        sortFilter,
        toast
      );
    }
  }, [filters?.startDate, filters?.endDate]);

  const timeLogUsers = dashBoardData
    ?.filter((user: any) => user.timeLogData.total_count !== "0")
    .sort((a: any, b: any) => a.displayName.localeCompare(b.displayName));

  const leaveUsers = dashBoardData
    ?.filter((user: any) => user.leaveData.total_count !== "0")
    .sort((a: any, b: any) => a.displayName.localeCompare(b.displayName));

  return (
    <>
      <div className="tw-flex tw-flex-col md:tw-flex-row md:tw-justify-between md:tw-items-center tw-gap-2 tw-mt-4">
        <h1 className="tw-font-bold tw-text-xl sm:tw-text-2xl tw-text-black tw-ml-4">
          Worklog Dashboard
        </h1>
        <div className="tw-mr-4">
          {filters && (
            <CalendarDateSelector
              setDateRange={setFilters}
              disabled={
                exportTimelogLoading || exportLeavesLoading ? true : false
              }
            />
          )}
        </div>
      </div>
      <div className="tw-p-2 md:tw-p-4 tw-space-y-4 md:tw-space-y-6">
        {/* Time Log Section */}
        {dashBoardDataLoading ? (
          <>
            {dashBoardDataLoading && (
              <div className="tw-h-full tw-w-full  tw-ml-[100px] tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
                <ProgressSpinner />
              </div>
            )}
            <Card
              title={
                <div className="tw-text-lg md:tw-text-xl tw-font-semibold">
                  <div className="tw-flex tw-justify-between tw-items-center tw-gap-2 md:tw-gap-4">
                    <h3 className="tw-text-lg md:tw-text-xl tw-font-semibold tw-text-black">
                      <span className="tw-flex tw-items-center tw-gap-2">
                        <TimelogManagementIcon fill="#000000" />
                        Time Logs
                      </span>
                    </h3>
                    <Button
                      type="button"
                      icon="pi pi-upload"
                      label="Export"
                      loading={exportTimelogLoading}
                      className="tw-flex tw-px-9 tw-py-2 tw-rounded bg-secondary border-primary hover:tw-bg-[#3f3c3c] tw-text-white tw-font-medium focus:tw-shadow-none"
                      disabled
                    />
                  </div>
                </div>
              }
              className="tw-shadow-lg tw-rounded-xl md:tw-rounded-2xl tw-border tw-border-gray-200 tw-bg-[#f5fafd]"
            >
              <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-10 tw-gap-4 md:tw-gap-6">
                <div className="lg:tw-col-span-4">
                  <Skeleton width="100%" height="15rem" />
                </div>
                <div className="lg:tw-col-span-6">
                  <Skeleton width="100%" height="15rem" />
                </div>
              </div>
            </Card>
            <Card
              title={
                <div className="tw-text-lg md:tw-text-xl tw-font-semibold tw-text-black">
                  <div className="tw-flex tw-justify-between tw-items-center tw-gap-2 md:tw-gap-4">
                    <h3 className="tw-text-lg md:tw-text-xl tw-font-semibold tw-text-black">
                      <span className="tw-flex tw-items-center tw-gap-2">
                        <LeavesManagementIcon fill="#000000" />
                        Leaves
                      </span>
                    </h3>
                    <Button
                      type="button"
                      icon="pi pi-upload"
                      label="Export"
                      loading={exportLeavesLoading}
                      className="tw-flex tw-px-9 tw-py-2 tw-rounded bg-secondary border-primary hover:tw-bg-[#3f3c3c] tw-text-white tw-font-medium focus:tw-shadow-none"
                      disabled
                    />
                  </div>
                </div>
              }
              className="tw-shadow-lg tw-rounded-xl md:tw-rounded-2xl tw-border tw-border-gray-200 tw-bg-[#f5fafd]"
            >
              <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-10 tw-gap-4 md:tw-gap-6">
                <div className="lg:tw-col-span-4">
                  <Skeleton width="100%" height="15rem" />
                </div>
                <div className="lg:tw-col-span-6">
                  <Skeleton width="100%" height="15rem" />
                </div>
              </div>
            </Card>
          </>
        ) : (
          <>
            <Card
              title={
                <div className="tw-text-lg md:tw-text-xl tw-font-semibold">
                  <div>
                    <div className="tw-flex tw-justify-between tw-items-center tw-gap-2 md:tw-gap-4">
                      <h3 className="tw-text-lg md:tw-text-xl tw-font-semibold tw-text-black">
                        <span className="tw-flex tw-items-center tw-gap-2">
                          <TimelogManagementIcon fill="#000000" />
                          Time Logs
                        </span>
                      </h3>
                      {timeLogUsers?.length > 0 && (
                        <Button
                          type="button"
                          icon="pi pi-upload"
                          label="Export"
                          loading={exportTimelogLoading}
                          className="tw-flex tw-px-9 tw-py-2 tw-rounded bg-secondary border-primary hover:tw-bg-[#3f3c3c] tw-text-white tw-font-medium focus:tw-shadow-none"
                          onClick={() =>
                            exportDashBoardTimeLogData(
                              filters,
                              setExportTimelogLoading,
                              toast
                            )
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
              }
              className="tw-shadow-lg tw-rounded-xl md:tw-rounded-2xl tw-border tw-border-gray-200 tw-bg-[#f5fafd]"
            >
              {timeLogUsers?.length > 0 ? (
                <>
                  <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-10 tw-gap-4 md:tw-gap-6">
                    <div className="lg:tw-col-span-4">
                      <Card className="tw-h-full">
                        <TlPieChart totalTimeLogsCounts={totalTimeLogsCounts} />
                      </Card>
                    </div>
                    <div className="lg:tw-col-span-6">
                      <Card className="tw-h-full">
                        <DataTable
                          value={timeLogUsers}
                          className="tw-w-full"
                          stripedRows
                          scrollable
                          removableSort
                          scrollHeight="400px"
                          // globalFilterFields={["displayName"]}
                        >
                          <Column
                            field="displayName"
                            header={() => {
                              return (
                                <div
                                  className={`tw-text-[#1c1c1c] tw-flex tw-justify-between tw-w-full tw-items-center`}
                                >
                                  <span className="tw-font-bold">Name</span>
                                </div>
                              );
                            }}
                            className="tw-font-medium tw-text-[#222222]"
                            // filter
                            // filterPlaceholder="Search by name"
                            sortable
                            body={(rowData) => {
                              return (
                                <>
                                  <div
                                    className={`timelog-tooltip tw-text-[#1c1c1c] tw-flex tw-justify-between tw-w-full tw-items-center`}
                                    data-pr-tooltip={(() => {
                                      return `Line Manager: ${
                                        rowData?.timeLogData?.lineManager
                                          ?.displayName ?? ""
                                      }`;
                                    })()}
                                    data-pr-position="bottom"
                                  >
                                    <span>{rowData.displayName}</span>
                                  </div>
                                  <Tooltip target=".timelog-tooltip" />
                                </>
                              );
                            }}
                          />
                          <Column
                            header={headerTemplate(
                              "Pending",
                              "",
                              setSortFilter,
                              "tw-text-[#1c1c1c]"
                            )}
                            body={(rowData) => (
                              <span>{rowData.timeLogData.pending_count}</span>
                            )}
                          />
                          <Column
                            header={headerTemplate(
                              "Submitted",
                              "",
                              setSortFilter,
                              "tw-text-[#1c1c1c]"
                            )}
                            body={(rowData) => (
                              <span>{rowData.timeLogData.submitted_count}</span>
                            )}
                          />
                          <Column
                            header={headerTemplate(
                              "Submitted to Manager",
                              "",
                              setSortFilter,
                              "tw-text-[#1c1c1c] tw-w-[160px]"
                            )}
                            body={(rowData) => (
                              <span>
                                {rowData?.timeLogData
                                  ?.submitted_to_manager_count ?? "N/A"}
                              </span>
                            )}
                          />
                          <Column
                            header={headerTemplate(
                              "Approved by Manager",
                              "",
                              setSortFilter,
                              "tw-text-[#1c1c1c] tw-w-[180px]"
                            )}
                            body={(rowData) => (
                              <span>
                                {rowData?.timeLogData
                                  ?.approved_by_manager_count ?? "N/A"}
                              </span>
                            )}
                          />
                          <Column
                            header={headerTemplate(
                              "Rejected by Manager",
                              "",
                              setSortFilter,
                              "tw-text-[#1c1c1c] tw-w-[180px]"
                            )}
                            body={(rowData) => (
                              <span>
                                {rowData?.timeLogData
                                  ?.rejected_by_manager_count ?? "N/A"}
                              </span>
                            )}
                          />
                          <Column
                            header={headerTemplate(
                              "Rejected",
                              "",
                              setSortFilter,
                              "tw-text-[#1c1c1c]"
                            )}
                            body={(rowData) => (
                              <span>
                                {rowData?.timeLogData?.rejected_count ?? "N/A"}
                              </span>
                            )}
                          />
                          <Column
                            header={headerTemplate(
                              "Approved",
                              "",
                              setSortFilter,
                              "tw-text-[#1c1c1c]"
                            )}
                            body={(rowData) => (
                              <span>{rowData.timeLogData.approved_count}</span>
                            )}
                          />
                          <Column
                            header={headerTemplate(
                              "Missing Timelogs",
                              "",
                              setSortFilter,
                              "tw-text-[#1c1c1c]"
                            )}
                            body={(rowData) => (
                              <span>
                                {
                                  rowData.timeLogData
                                    .total_missing_timelog_count
                                }{" "}
                                {rowData.timeLogData
                                  .total_missing_timelog_count > 1
                                  ? "days"
                                  : rowData.timeLogData
                                      .total_missing_timelog_count === "0"
                                  ? ""
                                  : "day"}
                              </span>
                            )}
                          />
                        </DataTable>
                      </Card>
                    </div>
                  </div>
                  <div className="tw-mt-2 md:tw-mt-4 tw-text-right tw-font-semibold">
                    Total Users: {timeLogUsers.length}
                  </div>
                </>
              ) : (
                <p className="tw-text-gray-500 tw-text-center tw-text-[20px]">
                  No time log data available
                </p>
              )}
            </Card>
            {/* Leave Section */}
            <Card
              title={
                <div className="tw-text-lg md:tw-text-xl tw-font-semibold tw-text-black">
                  <div className="tw-flex tw-justify-between tw-items-center tw-gap-2 md:tw-gap-4">
                    <h3 className="tw-text-lg md:tw-text-xl tw-font-semibold tw-text-black">
                      <span className="tw-flex tw-items-center tw-gap-2">
                        <LeavesManagementIcon fill="#000000" />
                        Leaves
                      </span>
                    </h3>
                    {leaveUsers.length > 0 && (
                      <Button
                        type="button"
                        icon="pi pi-upload"
                        label="Export"
                        loading={exportLeavesLoading}
                        className="tw-flex tw-px-9 tw-py-2 tw-rounded bg-secondary border-primary hover:tw-bg-[#3f3c3c] tw-text-white tw-font-medium focus:tw-shadow-none"
                        onClick={() =>
                          exportDashBoardLeavesData(
                            filters,
                            setExportLeavesLoading,
                            toast
                          )
                        }
                      />
                    )}
                  </div>
                </div>
              }
              className="tw-shadow-lg tw-rounded-xl md:tw-rounded-2xl tw-border tw-border-gray-200 tw-bg-[#f5fafd]"
            >
              {leaveUsers.length > 0 ? (
                <>
                  <Card className="tw-h-full">
                    <DataTable
                      value={leaveUsers}
                      className="tw-w-full tw-text-black tw-font-semibold"
                      stripedRows
                      scrollable
                      removableSort
                      scrollHeight="400px"
                      // globalFilterFields={["displayName"]}
                    >
                      <Column
                        field="displayName"
                        header={() => {
                          return (
                            <div
                              className={`tw-text-[#1c1c1c] tw-flex tw-justify-between tw-w-full tw-items-center`}
                            >
                              <span className="tw-font-bold">Name</span>
                            </div>
                          );
                        }}
                        className="tw-font-medium tw-text-black"
                        sortable
                        // filter
                        // filterPlaceholder="Search by name"
                        body={(rowData) => {
                          return (
                            <>
                              <div
                                className={`timelog-tooltip tw-text-[#1c1c1c] tw-flex tw-justify-between tw-w-full tw-items-center`}
                                data-pr-tooltip={(() => {
                                  return `Line Manager: ${
                                    rowData?.leaveData?.lineManager
                                      ?.displayName ?? ""
                                  }`;
                                })()}
                                data-pr-position="bottom"
                              >
                                <span>{rowData.displayName}</span>
                              </div>
                              <Tooltip target=".timelog-tooltip" />
                            </>
                          );
                        }}
                      />
                      <Column
                        header={headerTemplate(
                          "Submitted",
                          "",
                          setSortFilter,
                          "tw-text-[#1c1c1c]"
                        )}
                        body={(rowData) => (
                          <span>{rowData.leaveData.submitted_count}</span>
                        )}
                      />
                      <Column
                        header={headerTemplate(
                          "Approved",
                          "",
                          setSortFilter,
                          "tw-text-[#1c1c1c]"
                        )}
                        body={(rowData) => (
                          <span>{rowData.leaveData.approved_count}</span>
                        )}
                      />
                      <Column
                        header={headerTemplate(
                          "Statutory Holidays",
                          "",
                          setSortFilter,
                          "tw-text-[#1c1c1c]"
                        )}
                        body={(rowData) => (
                          <span>{rowData.leaveData.holiday_count}</span>
                        )}
                      />
                      <Column
                        header={headerTemplate(
                          "Available Leaves",
                          "",
                          setSortFilter,
                          "tw-text-[#1c1c1c]"
                        )}
                        body={(rowData) => (
                          <span>{rowData.leaveData.available_leaves}</span>
                        )}
                      />
                    </DataTable>
                  </Card>
                  <div className="tw-mt-2 md:tw-mt-4 tw-text-right tw-font-semibold">
                    Total Users: {leaveUsers.length}
                  </div>
                </>
              ) : (
                <p className="tw-text-gray-500 tw-text-center tw-text-[20px]">
                  No leave data available
                </p>
              )}
            </Card>
          </>
        )}
      </div>
    </>
  );
};

export default TimeLogDashboard;
